import React, {forwardRef} from 'react'
import {imageProvider} from 'utils/imageProvider'

import {GallerySingleView} from '@vio/shared/src/accommodation/GallerySingleView/GallerySingleView'

import {GalleryGridLoading} from './GalleryGridLoading'
import {GalleryGridView} from './GalleryGridView'

interface Props {
  images: string[]
  selectedImage?: string
  isLoading?: boolean
  selectedCategory?: string
  setSelectedImage: (image: string) => void
}
export const GalleryView = forwardRef<HTMLDivElement, Props>(
  (
    {images, selectedImage, setSelectedImage, selectedCategory, isLoading},
    ref
  ) => {
    if (isLoading) {
      return <GalleryGridLoading />
    }

    return (
      <>
        {selectedImage && (
          <GallerySingleView
            imageProvider={imageProvider}
            images={images}
            selectedImage={selectedImage}
            selectedCategory={selectedCategory}
          />
        )}
        <GalleryGridView
          ref={ref}
          onImageSelect={setSelectedImage}
          images={images}
          hasSelectedImage={!!selectedImage}
        />
      </>
    )
  }
)
GalleryView.displayName = 'GalleryView'
